import { useSelector } from 'react-redux';
import type { RootReduxState } from 'app/shared/flux/reducers';
import map from 'lodash/map';
import ExpandSearchButton from './ExpandSearchButton';
import queryUtils from 'app/shared/utils/queryUtils';
import Text from 'app/shared/core/Text';
import { adapt_reduxToQuery } from 'app/shared/flux/actions/FilterActions/adapters';
import {
  expandMySearchCSS,
  homeHubExpandMySearchCSS,
  homeHubSectionTitleContainerCSS,
  homeHubSectionTitleCSS,
} from 'app/shared/modules/HomeHub/styles';

const ExpandMySearch = () => {
  const filter = useSelector((state: RootReduxState) => state.filter);
  const expandMySearchName = useSelector((state: RootReduxState) => state.homehub.expandMySearchName);
  // Type assertion: runtime data is actually objects, not strings as typed in reducer
  const otherPlaces = useSelector(
    (state: RootReduxState) => state.homehub.expandMySearch as unknown as Array<{ resourceId: string; name: string }>,
  );

  const getSearchRouteForArea = (areaResourceId: string): string => {
    // TODO: The url should already be calculated, and we shouldn't need all these functions
    const path = `/${areaResourceId}/${filter.search.slug}`;
    const queryObj = adapt_reduxToQuery({ filter });
    delete queryObj.propertyTypes;
    delete queryObj.orderBy;
    const url =
      path + queryUtils.stringify(queryObj as unknown as Record<string, string | number | boolean | undefined>);
    return url;
  };

  const sendAnalyticsEvent = (_action: string): void => {
    // Placeholder for future analytics implementation
  };

  const onAreaSelection = (): void => {
    sendAnalyticsEvent('Click');
  };

  if (otherPlaces.length === 0) {
    return <div className={expandMySearchCSS} aria-hidden="true" />;
  }

  return (
    <div className={expandMySearchCSS}>
      <div>
        <Text htmlTag="h2" size="xl">
          <strong>Expand my search</strong>
        </Text>
        <hr />
      </div>
      <div className={homeHubSectionTitleContainerCSS}>
        <h3 className={homeHubSectionTitleCSS}>If you like {expandMySearchName}</h3>
      </div>
      <div className={homeHubExpandMySearchCSS}>
        {map(otherPlaces, (place) => {
          return (
            <ExpandSearchButton
              key={place.resourceId}
              name={place.name}
              url={getSearchRouteForArea(place.resourceId)}
              areaSelection={onAreaSelection}
            />
          );
        })}
      </div>
    </div>
  );
};

export default ExpandMySearch;
